import { makeVar } from '@apollo/client';
import { jwtDecode } from 'jwt-decode';

const jwt = sessionStorage.getItem('jwt');

let decoded = null;
if (jwt) {
  decoded = jwtDecode(jwt);
}
export default makeVar({
  phoneNumber: '',
  couponCode:
    decoded?.coupon_code ||
    new URLSearchParams(window.location.search).get('coupon_code') ||
    import.meta.env.VITE_DEFAULT_COUPON_CODE,
});
